import { SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { Product } from '@setvi/shared/interfaces';
import { getStock } from 'pages/products/components';
import { Customer } from 'Services/MongoRealm/Types';
import { Box } from '@material-ui/core';
import { ProductValueWrapper } from '../product-value';

interface ProductHeaderStockProps {
  product: Product;
  selectedCustomer?: Customer;
  onClick?: () => void;
}

export const ProductHeaderStock = ({
  product,
  selectedCustomer,
  onClick
}: ProductHeaderStockProps) => {
  const stock = getStock(product.inventory, selectedCustomer);
  const dropship = product?.dropship || false;

  const content = () => {
    if (dropship)
      return (
        <SText title="Dropship" weight="semibold" fontColor={TextColor.Blue} />
      );
    if (!stock)
      return (
        <SText
          title="Out of stock"
          weight="semibold"
          fontColor={TextColor.Red}
        />
      );
    return (
      <ProductValueWrapper>
        <SText
          lineHeight="24px"
          title="In stock:"
          weight="bold"
          fontColor={TextColor.SlateGrey}
          style={{ marginRight: 4 }}
        />
        <SText
          lineHeight="24px"
          title={stock.toString()}
          fontColor={TextColor.Green}
          style={{ textDecoration: 'underline' }}
        />
      </ProductValueWrapper>
    );
  };

  return <Box onClick={() => onClick?.()}>{content()}</Box>;
};
